/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Footer.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Icon_1 = require("./Icon");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-footer");
var propTypes = {
    mobile: PropTypes.bool
};
exports.Footer = function Footer(_a) {
    var children = _a.children, mobile = _a.mobile, inModal = _a.inModal, className = _a.className;
    var cssClassNames = classnames(moduleClassName(), !!mobile && moduleClassName("isMobile"), !!mobile && !!inModal && moduleClassName("isMobile-inModal"), className);
    return React.createElement("footer", { className: cssClassNames }, children);
};
exports.Footer.propTypes = propTypes;
exports.FooterSelect = function FooterSelect(_a) {
    var children = _a.children, className = _a.className, selectProps = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("span", { className: classnames(moduleClassName("select"), className) },
        React.createElement("select", tslib_1.__assign({}, selectProps, { className: classnames(moduleClassName("selectInput")) }), children),
        React.createElement(Icon_1.Icon, { type: "select" })));
};
exports.FooterLink = function FooterLink(_a) {
    var _b = _a.Component, Component = _b === void 0 ? "a" : _b, active = _a.active, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["Component", "active", "children", "className"]);
    return (React.createElement(Component, tslib_1.__assign({}, props, { className: classnames(moduleClassName("link"), active && moduleClassName("link-isActive"), className) }), children));
};
exports.FooterLink.propTypes = {
    active: PropTypes.bool,
    Component: PropTypes.node
};
exports.FooterLink.defaultProps = {
    Component: "a"
};
exports.FooterCopyright = function FooterCopyright(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("span", { className: classnames(moduleClassName("copyright"), className) }, children));
};